import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import VerticalNavBar from "../VerticalNavBar";
import TodoCard from "./TodoList/TodoCard";
import TodoItem from "./TodoList/TodoItem";
import SelectTodo from "./TodoList/selectCard";
import NewItemInput from "./TodoList/InputItem";
import API from "../../utils/api";

const TodoList = (props) => {
  props.setLearning(true);
  const [items, setItems] = useState({});
  const [cards, setCards] = useState({});
  const [roots, setRoots] = useState([]);

  const [selected, setSelected] = useState("notDone");

  const refresh = () => {
    API.get("/api/learning/refreshTodoList")
      .then((res) => res.data)
      .then((data) => {
        setItems(data.items);
        setCards(data.cards);
        setRoots(data.rootsElements);
      })
      .catch((e) => {
        alert("Error: ", e);
      });
  };
  useEffect(() => {
    API.get("/api/learning/getTodoList")
      .then((res) => res.data)
      .then((data) => {
        setItems(data.items);
        setCards(data.cards);
        setRoots(data.rootsElements);
      })
      .catch((e) => {
        alert("Error in Fetching! ", e.message);
      });
  }, []);
  const [edit, setEdit] = useState(false);

  return (
    <>
      {/* <Particle /> */}
      <Container>
        <Particle />
      </Container>
      <Container fluid className="todo-section">
        <h2>To-do List</h2>
        <SelectTodo
          refresh={refresh}
          setItem={setSelected}
          edit={edit}
          setEdit={setEdit}
        />
        <Col>
          <Row>
            <VerticalNavBar
              setIsAuthenticated={props.setIsAuthenticated}
              setLearning={props.setLearning}
            />
          </Row>
        </Col>
        {roots.map((item, index) => {
          // Check the selected filter
          if (
            selected === "both" ||
            (selected === "done" && item.done === true) ||
            (selected === "notDone" && item.done === false)
          ) {
            return item.type === "item" ? (
              <TodoItem key={index} item={items[item._id]} edit={edit} />
            ) : (
              <TodoCard
                key={index}
                edit={edit}
                cards={cards}
                items={items}
                card={cards[item._id]}
                refresh={refresh}
              />
            );
          } else {
            return null; // Return nothing if the item doesn't match the selected filter
          }
        })}
        {edit && <NewItemInput refresh={refresh} />}
      </Container>
    </>
  );
};

export default TodoList;
